import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

export const content = css`
  margin: 0;
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});
  color: var(${colors.content.default});
`;

export const heading = css`
  font-size: var(${typography.heading.sizes.xs.fontSize});
  line-height: var(${typography.heading.sizes.xs.lineHeight});
  margin: 0 0 var(${spacing.xs});
  color: var(${colors.content.default});
`;

export const accentLink = css`
  display: inline-block;
  font-weight: 700;
  text-decoration: none;
  margin-top: var(${spacing.lg});
  color: var(${colors.content.brand});
  text-decoration: underline;

  &:hover,
  &:focus {
    border-radius: 4px;
  }
`;
